import React, { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast } from 'react-toastify';
import Popup from "reactjs-popup";
import Box from "@mui/material/Box";
import BannerForm from "./BannerForm";
import BannerTable from "./BannerTable";
import "../main_business/business/business.css"; 
import { getConfig } from "../../../../network/auth";
import { baseUrl } from "../../../../network/constants/constants";
import axios from "axios";

export const BannerScreen = () => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [formErrors, setFormErrors] = useState({});
    
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [selectedBannerToDelete, setSelectedBannerToDelete] = useState(null);

    const config = useMemo(() => getConfig(), []);

    const fetchBanners = () => {
        setLoading(true);
        axios.get(`${baseUrl}app/banner/`, config)
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : response.data.results;
                setBanners(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Fetch Error:", error);
                toast.error("Failed to load banners");
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchBanners();
    }, []);

    const handleShowModal = (banner = null) => {
        setFormErrors({});
        setSelectedBanner(banner);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBanner(null);
        setFormErrors({});
    };

    const handleDeleteClick = (banner) => {
        setSelectedBannerToDelete(banner);
        setShowDeletePopup(true);
    };

    const confirmDelete = () => {
        const url = `${baseUrl}app/banner/delete/${selectedBannerToDelete.id}/`;
        axios.delete(url, config)
            .then(() => {
                toast.success("Banner deleted successfully!");
                fetchBanners();
                setShowDeletePopup(false);
            })
            .catch((error) => {
                console.error("Delete Error:", error);
                toast.error("Error deleting banner.");
                setShowDeletePopup(false);
            });
    };

    const handleFormSubmit = (formData) => {
        setFormErrors({});
        const isEdit = !!selectedBanner;
        const url = isEdit
            ? `${baseUrl}app/banner/edit/${selectedBanner.id}/`
            : `${baseUrl}app/banner/create/`;
        
        const method = isEdit ? "patch" : "post";
        const form = new FormData();
        form.append("link_type", formData.link_type);
        form.append("link", formData.link || "");

        if (formData.image instanceof File) {
            form.append("image", formData.image);
        }

        const uploadConfig = { ...config };
        if (uploadConfig.headers) {
            delete uploadConfig.headers['Content-Type'];
        }

        axios({
            method,
            url,
            data: form,
            headers: uploadConfig.headers,
        })
            .then(() => {
                toast.success(isEdit ? "Banner updated successfully!" : "Banner created successfully!");
                fetchBanners();
                handleCloseModal();
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    setFormErrors(error.response.data);
                }
                toast.error("Error saving banner.");
            });
    };

    return (
        <>
            <Box sx={{ width: "80%", margin: "auto" }} className="main-div">
                <button className="btn-add" onClick={() => handleShowModal()}>
                    + Add Banner
                </button>
                
                {loading ? (
                    <div className="loader-container">
                        <Spinner animation="border" className='spinner-loader' />
                    </div>
                ) : (
                    <BannerTable
                        banners={banners}
                        onEdit={handleShowModal}
                        onDelete={handleDeleteClick}
                    />
                )}
                
                <BannerForm
                    show={showModal}
                    handleClose={handleCloseModal}
                    handleSubmit={handleFormSubmit}
                    banner={selectedBanner}
                    errors={formErrors}
                />
            </Box>

            <Popup
                open={showDeletePopup}
                onClose={() => setShowDeletePopup(false)}
                contentStyle={{
                    borderRadius: "20px",
                    backgroundColor: "white",
                    padding: "20px"
                }}
                modal
                nested
            >
                {(close) => (
                    <div className="delete-img-div">
                        <h3 className="delete-img-heading">Are you sure?</h3>
                        <p className="delete-img-p">Do you really want to delete this banner?</p>
                        <div className="delete-btn-div">
                            <button
                                onClick={() => {
                                    confirmDelete();
                                    close();
                                }}
                            >
                                Delete
                            </button>
                            <button onClick={close}>Cancel</button>
                        </div>
                    </div>
                )}
            </Popup>
        </>
    );
};

export default BannerScreen;